import {createSlice} from "@reduxjs/toolkit"

const initialState={
    banner:[],
    wallDecorItem:[]
}

const bannerSlice=createSlice({
    name:"bannerslice",
    initialState,
    reducers:{
        bannerImage:(state,action)=>{
            state.banner=action.payload
        },
        wallDecorate:(state,action)=>{
            state.wallDecorItem=action.payload
        }
    }
});

export const{bannerImage,wallDecorate}=bannerSlice.actions;

export default bannerSlice.reducer;